import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipe'
})
export class PipePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}

@Pipe({
  name: 'newsCats'
})
export class NewsCatsPipe implements PipeTransform {
  transform(value: number, ...args: any[]): string {
    if (value === 0) {
      return '資訊安全';
    } else if(value === 1){
      return '技術開發';
    }
    else if(value ===2){
      return '外部來源';
    }
  }
}
